import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Typography,
  Divider,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import toast from "react-hot-toast";
import axios from "axios";
import { useNavigate } from "react-router-dom"; 
import { URL } from "../config";
import { MaterialReactTable } from "material-react-table";

const LoginDetails = () => {
  const [data, setData] = useState([]); 
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); 

  
  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${URL}/get`);
      if (res.data && Array.isArray(res.data.data)) {
        setData(res.data.data);
      } else if (Array.isArray(res.data)) {
        setData(res.data);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (err) {
      console.error("Error loading login details:", err);
      toast.error(" Failed to load records");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

 
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    try {
      await axios.delete(`${URL}/logins/${id}`);
      toast.success(" Deleted successfully!");
      fetchData();
    } catch (err) {
      toast.error(" Failed to delete record");
    }
  };


  const columns = [
    {
      header: "Actions",
      Cell: ({ row }) => (
        <Box>
          <IconButton
            color="error"
            onClick={() => handleDelete(row.original.id)}
          >
           <DeleteIcon sx={{ fontSize: 14 }} />


          </IconButton>
        </Box>
      ),
    },
    { accessorKey: "username", header: "Username" },
    { accessorKey: "plainPassword", header: "Password" }, 
    { accessorKey: "role", header: "Role" },
  ];

  return (
    <Paper
      sx={{
        p: 2,
        m: 2,
        borderRadius: 3,
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
       <div className="head-bg" >
          <h4 className="heading">Login Details</h4>
        </div>
      </Box>

      <Divider sx={{ borderColor: "#037589ff", mb: 1 }} />

      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          sx={{
            fontWeight: 600,
            borderRadius: 2,
            px: { xs: 2, sm: 3 },
            py: { xs: 0.5, sm: 1 },
            fontSize: { xs: "0.7rem", sm: "0.875rem" },
            backgroundColor: "#037589ff",
          }}
          variant="contained"
          size="small"
          startIcon={<AddCircleIcon fontSize="small" />}
          onClick={() => navigate("/dashboard/user-access-login")}
        >
          Add New
        </Button>
      </Box>

      <Box
        sx={{
          width: "100%",
          overflowX: "auto",
          WebkitOverflowScrolling: "touch",
          boxShadow: "2px 2px 8px rgba(0,0,0,0.2)",
        }}
      >
        <Box sx={{ minWidth: 800 }}>
          <MaterialReactTable
                               columns={columns}
                               data={data}
                               enableColumnActions={false}
                               enableDensityToggle={false}
                               enableFullScreenToggle={false}
                               initialState={{ density: "compact", pagination: { pageSize: 5 } }}
                               muiTablePaperProps={{ sx: { boxShadow: "none" } }}
                               muiTableContainerProps={{ sx: { width: "100%" } }}
                               muiTableHeadCellProps={{
                                 sx: {
                                   backgroundColor: "#037589ff",
                                   color: "#fff",
                                   fontWeight: "bold",
                                   fontSize: { xs: "9px", sm: "12px" },
                                   whiteSpace: "nowrap",
                                   textAlign: "left",
                                   pl: { xs: 1, sm: 2 },
                                   pr: { xs: 1, sm: 2 },
                                   p: "3px",
                                 },
                               }}
                               muiTableBodyRowProps={{
                                 sx: {
                                   "& td": {
                                     fontSize: { xs: "9px", sm: "12px" },
                                     p: "3px",
                                     pl: { xs: 1, sm: 2 },
                                     pr: { xs: 1, sm: 2 },
                                     whiteSpace: "nowrap",
                                     textAlign: "left",
                                   },
                                 },
                               }}
                             />
        </Box>
      </Box>
    </Paper>
  );
};

export default LoginDetails;
